import LeadFormWrapper from '@v4/common/components/organisms/LeadFormWrapper/LeadFormWrapper';

export { EnumFormIds, ConsentValues, GuIdK } from '@v4/common/components/organisms/LeadFormWrapper/constants';

export default LeadFormWrapper;
